<h2 mat-dialog-title>{{'documentos.deletemodal.title' | translate}}</h2>
<div mat-dialog-content>
  <span class="mat-caption">{{'documentos.deletemodal.text' | translate }}</span>
</div>
<div mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
  <button mat-button color="primary" [mat-dialog-close]="false">
    {{'documentos.deletemodal.cancel' | translate }}
  </button>
  <button mat-button color="warn" [mat-dialog-close]="true">
    {{'documentos.deletemodal.ok' | translate }}
  </button>
</div>

